// extracted by mini-css-extract-plugin
var _1 = "DashboardTileGrip-modulegrip__kZQ2q IconNG-moduleiconContainer__SxWZ0";
export { _1 as "grip" }
